<template>
 <section class="newTable" >
  <table class="table datatable table-striped area-list-datatable" id="CathayFamilyDataTable" >
    <thead>
      <tr>
        <th width="120">
          <div class="checkbox checkbox-inline mr-0">
            <input 
            @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
            type="checkbox" 
            name="check-all" 
            id="check-all" 
            value="1" 
            v-model="checkAll">
            <label for="check-all"></label>
          </div>
          <span>#</span>
        </th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('name')"
        >姓名</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('id')"
        >身分證</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'mobile' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('mobile')"
        >手機</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'birthday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('birthday')"
        >生日</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'apply' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('surplus_times')"
        >VIP權益次數</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'apply' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('apply')"
        >一家人申請狀況</th>
        <th
        width="140"
        >一家人申請書列印</th>
        <!--
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'apply' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('apply')"
        >專屬優惠資格</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'newyear_gift' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('newyear_gift')"
        >年節禮資格</th>
          -->
        <th
        width="148"
        >排訪</th>
      </tr>
    </thead>
    <tbody @scroll="scrollmethod" class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableDataBackup" :key="`CathayFamilyDataTable-table-td-${did}`">
          <td width="120">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                type="checkbox"
                name="`td-item[]`"
                :id="`CathayFamilyDataTable-check-${did}`"
                :value="d.id"
                v-model="selection"
                :disabled="d.id === ''"
                @change="$emit('update', selection)">
                <label :for="`CathayFamilyDataTable-check-${did}`"></label>
              </div>
              
              <span>
              <span class="no">{{did + 1}}</span>
              <span class="info text-center">
                <level :lv="Number(d.vip_level)" />
                <avatar :gender="Number(d.sex)" :size="20" />
              </span>
              </span>
            </div>
          </td>
          <td width="*">
            <Tooltip  :position="did < 3?'bottom':'top'" :name="d.name" :birthday="d.birthday" :mobile="d.mobile" :id="d.id" >
              <a v-if="d.is_exist" class="text-green text-underline pointer-cursor" @click="routerToCust(d.id, d.name)">{{d.name | getMaskName}}</a>
              <a v-else >{{d.name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td width="*">{{d.id | getMaskID}}</td>
          <td width="*">{{d.mobile | emptyField | getMaskMobile}}</td>
          <td width="*">
            <span>
                <div class="date">{{d.birthday | dateFormat | getMaskBirthday}}</div>
                <div class="age">
                  <b>{{ d.age? d.age : '— —' }}</b>
                  <span v-if="d.age">歲</span>
                  <span v-else></span>                 
                </div>
              </span>
          </td>
          <td width="*">
            <span>
              <a
                class="text-blue text-underline pointer-cursor"
                @click="$emit('benefits-times', d.id)"
              >查詢</a>
            </span>
          </td>
          <td width="140">
            <span v-if="d.apply == 'Y'">
              <a
                class="text-blue text-underline pointer-cursor"
                @click="$emit('health-present', d.id, d.name)"
              >已申請</a>
            </span>
            <span v-else class="text-red">未申請</span>
          </td>
          <td width="*">
            <a class="text-green text-underline pointer-cursor" @click="$emit('print-modal', d)">列印</a>
          </td>
           <!--
          <td width="*" class="text-center">
            <span v-if="d.apply == 'Y'">
              符合
              <img
                :src="`${BaseUrl}assets/common/gift.png`"
                width="40"
                alt="gift"
                class="img-style"
              />
            </span>
            <span v-else>未符合</span>
          </td>
          <td width="*" class="text-center">
            <span v-if="d.newyear_gift == 'Y'">
              符合
              <img
                :src="`${BaseUrl}assets/common/gift.png`"
                width="40"
                alt="gift"
                class="img-style"
              />
            </span>
            <span v-else>未符合</span>
          </td>
          -->
          <td v-if="isBox" :width="iPadWidth">
            <button 
            v-if="!d.visit.csidno"
            class="btn btn-primary" 
            @click="callBoxVisit(d)"
            v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
            <button 
            v-else
            class="btn btn-primary" style="font-size:0.8rem;" 
            @click="callBoxVisit(d)">{{ d.visit.str_date | dateFormat }}<br>{{ d.visit.str_time }}</button>
          </td>
          <td v-else :width="iPadWidth">
            <button 
            v-if="!d.visit.csidno"
            class="btn btn-primary" 
            @click="$emit('scheduled-access', d)"
            v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
            <button 
            v-else
            class="btn btn-primary" style="font-size:0.8rem;" 
            @click="$emit('scheduled-access', d)">{{ d.visit.str_date | dateFormat }}<br>{{ d.visit.str_time }}</button>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>
              無客戶名單資料
            </h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
    </tbody>
  </table>
  </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Level from '@/components/Level'
import Avatar from '@/components/Avatar'
import { commonMixin } from '@/mixins/common'
import { setTimeout } from 'timers';
import Tooltip from '@/desktop/components/ToolTip'

const is_iPad = navigator.userAgent.match(/iPad/i) != null // 確認裝置是否為 iPad
let idmarkWidth = 148
if(is_iPad){
  idmarkWidth = 131
}

export default {
    name: "CathayFamilyDataTable",
    mixins: [commonMixin],
    components: {Level, Avatar, Tooltip},
    props: {
        tableData: {
            type: Array,
            default: () => {
                return []
            }
        },
        height: {
            type: Number,
            default: () => {
                return 350
            }
        },
        //名單專區資訊
        categoryInfo: {
          type: Object,
          default: () => {
            return {};
          }
        }
    },
    data() {
        return {
            order: {
                fieldName: 'name',
                asc: true
            },
          checkAll: false,
          clickTarget: '',
          tableDataBackup: [],
          allIdData: [],
          selection: [],
          currentWidth: 0,
          is_iPad: is_iPad,
          iPadWidth: idmarkWidth,
        }
    },
    computed : {
      ...mapGetters([ 'UserInfo', 'BaseUrl' ]),
      isBox() {
       //判斷是否為box
       return this.UserInfo.userType === 'box'
      }
    },
    watch: {
      tableData: function () {
        this.init()
      },
      clickTarget: function(target){
        if(target == 'clickAll' || target == 'clickAll-again') {  //點了全選checkbox
          if(this.checkAll) {  //點了全選
            this.selection = []
            this.allIdData.forEach(data => {
              this.selection.push(data)
            });
          } else {  //取消全選
            this.selection = []
          }
        } else {  //點了其他checkbox
          this.checkAll = this.selection.length == this.allIdData.length
        }
        this.$emit('update', this.selection)
      },
    },
    methods: {
    ...mapActions([
      'setPageLock', 'updateCustID'
    ]),            
      scrollmethod(e){
        // this.nowTime = +new Date()
        // if(this.nowTime > this.lastTime + 150){
        //   this.lastTime = this.nowTime
        //   if (!this.scrollDataLoading && e.target.scrollTop > (e.target.scrollHeight - 700)) {
        //     this.options.scrollLoadingAPI()
        //   }
        // }
      },
      columnSorting (fieldName) {
        console.log(`>>>>> columnSorting:${fieldName} <<<<<`)
        //切換表頭圖案
        if(this.order.fieldName == fieldName) {
            this.order.asc = !this.order.asc
        } else {
          console.log('change sort field')
          this.order.fieldName = fieldName
          this.order.asc = true
          console.log(this.order)
        }

        //data排序
        let sortOrder = -1
        if(this.order.asc) {
          sortOrder = 1
        }
        switch (fieldName) {
          case 'birthday':
          this.tableDataBackup = []  
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData]  
            this.tableDataBackup.sort(this.sortCompareFun(sortOrder, "birthdaySort"))
            this.registerHanlink()  // for 難字更新
          }, 20)
            break;
          default:
          this.tableDataBackup = []  
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData]             
            this.tableDataBackup.sort(this.sortCompareFun(sortOrder, fieldName))
            this.registerHanlink()  // for 難字更新
          }, 20)
        }
      },
      dateCompareFun(sortOrder, property) {
        let vm = this
        return function(a, b) {
          let date_a = new Date(a[property]? a[property] : '1880-01-01').getTime() 
          let date_b = new Date(b[property]? b[property] : '1880-01-01').getTime() 
          let result = (date_a < date_b) ? -1 : 1
          return result * sortOrder
        }
      },
      sortCompareFun(sortOrder, property) {
        return function(a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      },       
      routerToCust(custID, custName) {
        if (this.isBox) {
          //若内嵌於Box, 將客戶資訊回傳給Box
          this.boxCustInfo(custID, custName);
        } else {
          this.updateCustID(custID);
          localStorage.CustID = custID;
          this.$router.push({path: `/detail/CustID/tab/1`});
        }
      }, 
      init() {
        this.checkAll = false
        this.selection = []
        this.tableDataBackup = this.tableData.map(ele => {return ele})
        this.allIdData = this.tableData.map(ele => {return ele.id})
        this.order.fieldName = 'name'
        this.order.asc = true
        this.registerHanlink(); // for hard word
      },
      callBoxVisit(data) {
        //連至Box排訪
        this.boxVisit(data, this.categoryInfo);
      },
      //回傳當前排序資料集
      getSortedList() {
        return this.tableDataBackup;
      }      
    },
    mounted () {
        this.currentWidth = this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1)
        if(!is_iPad) {
          this.iPadWidth = '131'
        }else{
          this.iPadWidth = '148'
        }
    }
}
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }
  
  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;
    
    &:before,
    &:after {
      content: '';
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027A39, .5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027A39, .5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, .5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, .5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}


.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.img-style {
  vertical-align: middle;
}
</style>
